module.exports = __webpack_public_path__ + "img/race.b3105f5b.png";